import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";

export const Page6 = () => {
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
        {/* <ul style={{ margin: "10px 40px" }} className="para">
          <li style={{ paddingLeft: "15px" }}>
            Established misappropriation of any Tangible and/or intangible
            assets of the Company
          </li>
          <li style={{ paddingLeft: "15px" }}>
            Intentional Misuse of Company or Company’s clientele data.
          </li>
        </ul>
        <p className="para">
          Your employment hereunder is only subject to the information and
          particulars furnished by you and if it transpires that you have made a
          false statement or concealed a material fact resulting in your
          employment with us, the Management may take such action as it deems
          fit in its sole discretion, including termination of your employment.
        </p>
        {/* <table
          className="tableStyle"
          border="1"
          cellSpacing="0"
          cellPadding="5"
          style={{margin:"80px 30px 0 40px"}}
        >
          <tr>
            <td rowSpan="2">Designation</td>
            <td colSpan="2" style={{textAlign:"center"}}>Notice Period</td>
          </tr>
          <tr>
            <td>During Probation</td>
            <td>After Probation</td>
          </tr>
          <tr>
            <td>Team Leaders and above</td>
            <td>30 days</td>
            <td>90 days</td>
          </tr>
          <tr>
            <td>Trainees / Executives</td>
            <td>30 days</td>
            <td>60 days</td>
          </tr>
        </table> */}
        {/* <table
          className="tableStyle"
          border="1"
          cellSpacing="0"
          cellPadding="5"
          style={{ margin: "25px 39px 0px 5px" }}
        >
          <thead>
            <tr>
              <td>Designation</td>
              <td colSpan="2" style={{ textAlign: "center" }}>
                Notice Period
              </td>
            </tr>
            <tr>
              <td />
              <td>During Probation</td>
              <td>After Probation</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Team Leaders and above</td>
              <td>30 days</td>
              <td>90 days</td>
            </tr>
            <tr>
              <td>Trainees / Executives</td>
              <td>30 days</td>
              <td>60 days</td>
            </tr>
          </tbody>
        </table>

        <p className="para" style={{ marginTop: "3px" }}>
          You are not eligible for any leave during the Notice Period
        </p> */} 
        {/* <p className="bolds" style={{ margin: "25px 0" }}>
          Indemnity:
        </p>
        <p className="para" style={{ margin: "25px 0" }}>
          You shall be responsible for properly and diligently performing the
          duties assigned to you, for maintaining the confidentiality of
          confidential information and trade secrets of the Company and for
          protecting the property of the Company entrusted to you in the due
          discharge of your duties. You shall fully indemnify and keep the
          Company fully Indemnified against any claim or demand made against the
          Company in this regard. You shall continue to indemnify the Company
          even after the expiry or termination of this employment against any
          claim or demand made against the Company with regard to any acts or
          omissions committed by you during your employment with us.
        </p> */}
        {/* <p className="para" style={{margin:"25px 0"}}>
          In the event of you leaving the Company prior to the completion of one
          (1) year from the commencement of this employment contract, you shall
          indemnify the company against all expenses, whatsoever, incurred on
          you by the Company by repaying any and all such expenses and
          reimbursements to the Company including but not limited to such amount
          which will be deducted from your Full and Final Settlement.
        </p> */}
      </div>
      <div className="parentcls">
        <p className="bolds">Policies and Standards:</p>
        <p className="para" style={{ marginTop: "15px" }}>
          {/* The Company has established a variety of policies and standards that
          ensures an enjoyable working environment. During the period of your
          employment with us, you agree to be bound by these policies and
          standards and any future policies and standards that are reasonably
          introduced by the Company.
        </p>
        <p className="para">
          It is agreed that the introduction and administration of these
          policies is within the sole discretion of the Company and that these
          policies do not form a part of this Contract. It is agreed that if the
          Company introduces, amends or deletes employment-related policies as
          conditions warrant then such introduction, deletion or amendment does
          not constitute a breach of this Contract. */}
          The Company has established various policies and standards to ensure a positive and productive working environment. During your employment, you agree to comply with all such policies and standards, as well as any future policies reasonably introduced by the Company. 

The introduction, administration, amendment, or deletion of these policies is at the sole discretion of the Company and does not form part of your employment contract. Any changes to employment-related policies by the Company shall not be considered a breach of this Contract. 
        </p>
         <p className="bolds" style={{ margin: "15px 0" }}>
          Code of Conduct:
        </p>
        <p className="para">
          You shall perform your duties with honesty, integrity and fairness.
          You shall act in good faith, responsibly, with due care, competence
          and diligence, during the term of your employment. You shall act in
          the best interests of the Company and fulfil your service obligations.
          You shall not receive/offer, directly or indirectly, any gifts,
          donations, illegal payments and comparable benefits which are intended
          or perceived to be intended to obtain business (or uncompetitive)
          favours.
        </p>
        <p className="para" style={{ marginTop: "15px" }}>
          You shall:
        </p>
        <p className="para">
          uphold ethical standards of integrity; <br />
          Act objectively and constructively while exercising your duties;{" "}
          <br /> Exercise your responsibilities in a bona-fide manner in the
          interest of the Company; <br />
          Ensure undivided time and attention to your professional obligations
          during business hours; <br /> refrain from any action/practice that
          could lead to a loss of your employment; <br /> Ensure that your
          appearance is neat and groomed at all times when at work.
        </p>

         <p className="bolds" style={{ margin: "20px 0" }}>
          Employment Dispute and Jurisdiction:
        </p>
        <p className="para">
          In the event of any dispute arising out of the interpretation or
          implementation of this employment terms and conditions, this shall be
          referred to arbitration. The parties to this contract shall endeavour
          to mutually agree and decide on the name of a sole arbitrator to
          conduct such arbitration. In the event that the parties cannot reach
          contract on the name of a sole arbitrator, they agree to approach the
          Hon’ble High Court of Chennai to
        </p>
        <p className="para">
          appoint such sole arbitrator. The provisions of the Arbitration and
          Conciliation Act, 1996, shall govern the proceedings. The award of the
          arbitrator shall be final and binding. The venue for such arbitration
          shall be Chennai. For all other matters the Courts at Chennai shall
          have exclusive jurisdiction.
        </p>
         <p className="para">
          Notwithstanding the above, in the event of breach of any of the terms
          herein, the Company shall be entitled to other adequate and
          appropriate legal remedies as deemed fit. This agreement shall be
          governed by the laws of India and the Courts of Chennai shall alone
          have jurisdiction.
        </p>
      </div>
    </ReusablePDFLayout>
  );
};
